<template>
  <div>
    <h3 class="md-title">
      <md-icon>trip_origin</md-icon>
      경조사 통계(교우회)
    </h3>
    <div class="md-layout">
      <div class="md-layout-item md-size-20 no-padding">
        <md-card>
          <md-card-header md-alignment="space-between">
            <h4 class="title">
              <md-icon>receipt_long</md-icon>
              검색 조건
            </h4>
          </md-card-header>
          <md-card-content>
            <table class="flex-table">
              <tr>
                <th>조회 기간</th>
                <td>
                  <div class="inline-flex mb5">
                    <input type="text" v-model="query.fromDate" v-mask="'####-##-##'">
                    <span class="date-txt">부터</span>
                  </div>
                  <div class="inline-flex mb5">
                    <input type="text" v-model="query.toDate" v-mask="'####-##-##'">
                    <span class="date-txt">까지</span>
                  </div>
                  <div class="inline-flex">
                    <button class="btn-sm"
                            @click="onClickPeriodButton(3, 'months')"
                    >
                      3개월
                    </button>
                    <button class="btn-sm"
                            @click="onClickPeriodButton(6, 'months')"
                    >
                      6개월
                    </button>
                    <button class="btn-sm"
                            @click="onClickPeriodButton(1, 'year')"
                    >
                      1년
                    </button>
                    <button class="btn-sm"
                            @click="onClickPeriodButton(2, 'years')"
                    >
                      2년
                    </button>
                  </div>
                </td>
              </tr>
            </table>
          </md-card-content>
          <md-card-actions>
            <md-button class="md-info md-sm full-size-button"
                       @click="sendQuery"
            >
              <md-icon>check</md-icon>
              검색
            </md-button>
          </md-card-actions>
        </md-card>
      </div>
      <div class="md-layout-item md-size-80 no-padding">

        <md-card>
          <md-card-header md-alignment="space-between">
            <h4 class="title">
              <md-icon>assignment</md-icon>
              통계 상세 내역
            </h4>
          </md-card-header>

          <md-card-content>
            <table class="flex-table td-text-align-right">
              <tr>
                <th>종합</th>
                <td>{{listTotalCount}} 건</td>
              </tr>
            </table>
            <div class="md-layout">
              <div class="md-layout-item md-size-50 no-padding">
                <h4>조치구분별</h4>
                <table class="flex-table td-text-align-right">
                  <tr>
                    <th></th>
                    <th>건수</th>
                    <th>금액</th>
                  </tr>
                  <tr
                    v-for="item in actTotalData"
                    :key="item.id"
                  >
                    <td>{{item.label}}</td>
                    <td>{{formatter.getCurrency(item.count)}} 건</td>
                    <td>{{formatter.getCurrency(item.amt)}} 원</td>
                  </tr>
                </table>
              </div>
              <div class="md-layout-item md-size-50 no-padding">
                <h4>업체별</h4>
                <table class="flex-table td-text-align-right">
                  <tr>
                    <th></th>
                    <th>건수</th>
                    <th>금액</th>
                  </tr>
                  <tr
                    v-for="item in storeTotalData"
                    :key="item.id"
                  >
                    <td>{{item.label}}</td>
                    <td>{{formatter.getCurrency(item.count)}} 건</td>
                    <td>{{formatter.getCurrency(item.amt)}} 원</td>
                  </tr>
                </table>
              </div>
            </div>
          </md-card-content>

        </md-card>
      </div>
    </div>
  </div>
</template>
<script>
import formatter from "@/kuaa/kuaa-formatter";
import kuaaApi from "@/kuaa/kuaa-api";
import URL_CONST from "@/kuaa/kuaa-url-const";
import kuaaFnc from "@/kuaa/kuaa-comm-func";

import Swal from "sweetalert2";
import moment from "moment";


import { Grid } from '@toast-ui/vue-grid';
import 'tui-grid/dist/tui-grid.css';
import 'tui-pagination/dist/tui-pagination.css';

export default {
  name: "familyEventStatisticsComp",

  props: {
  },

  components: {
  },

  created() {
    this.initQueryDate();
  },

  computed: {
  },

  data() {
    return {
      formatter,
      query: {
        fromDate: null,
        toDate: null
      },
      actTotalData : {},
      storeTotalData : {},
      listTotalCount : null
    };
  },

  methods: {
    initQueryDate() {
      let now = moment();
      this.query.toDate = now.format("YYYY-MM-DD");
      // this.query.fromDate = now.subtract(3, "years").format("YYYY-MM-DD");
    },

    onClickPeriodButton(num, type) {
      this.query.fromDate = moment().subtract(num, type).format("YYYY-MM-DD");
    },

    parseEventStatist(arr){
      let tempActObj = {};
      let tempStoreObj = {};

      arr.forEach((obj)=>{
        // 조치 구분별
        if(obj.actCdNm && obj.actCdNm != ''){
          if(!tempActObj[obj.actCdNm]){
            tempActObj[obj.actCdNm] = {
              label : obj.actCdNm,
              count : 0,
              amt : 0
            }
          }
          tempActObj[obj.actCdNm]['count']++;
          if(obj.amt && obj.amt != ''){
            tempActObj[obj.actCdNm]['amt'] += Number(obj.amt);
          }
        }

        // 업체별
        if(obj.storeCdNm && obj.storeCdNm != ''){
          if(!tempStoreObj[obj.storeCdNm]){
            tempStoreObj[obj.storeCdNm] = {
              label : obj.storeCdNm,
              count : 0,
              amt : 0
            }
          }
          tempStoreObj[obj.storeCdNm]['count']++;
          if(obj.amt && obj.amt != ''){
            tempStoreObj[obj.storeCdNm]['amt'] += Number(obj.amt);
          }
        }
      });
      this.actTotalData = tempActObj;
      this.storeTotalData = tempStoreObj;
    },

    sendQuery(){
      let params = {
        startDate : this.customFormatter(this.query.fromDate),
        endDate : this.customFormatter(this.query.toDate),
        page : 1,
        perPage : 10000,
        scrDiv: 'tot'
      }
      let modalOptions = kuaaFnc.getSwalModaloptions();
      kuaaApi.sendServer(
        URL_CONST.GET_PRIZE_LIST,
        params,
        "post",
        response => {
          if (response.data.result){
            this.listTotalCount = response.data.data.pagination.totalCount;
            this.parseEventStatist(response.data.data.contents);
          } else {
            modalOptions.html = `조회 실패 하였습니다.`;
            Swal.fire(modalOptions);
          }
        }
      );
    },

    customFormatter(date) {
      let res = date && date != '' ? moment(date).format("YYYYMMDD") : '';
      return res;
    },

  }
};
</script>

<style lang="css" scoped>
</style>